var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idNarasumber),
      expression: "idNarasumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "id_narasumber"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.idNarasumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("[ Pilih Narasumber ]")]), _vm._v(" "), _vm._l((_vm.list_narasumber), function(option) {
    return _c('option', {
      domProps: {
        "value": option.idNarasumber
      }
    }, [_vm._v("\n                                                " + _vm._s(option.nama) + " (" + _vm._s(option.singkatan) + ")\n                                            ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "type": "text",
      "id": "namaLengkap",
      "placeholder": "Masukkan Nama Lengkap"
    },
    model: {
      value: (_vm.namaLengkap),
      callback: function($$v) {
        _vm.namaLengkap = $$v
      },
      expression: "namaLengkap"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Masukkan Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "type": "text",
      "id": "username",
      "placeholder": "Masukkan Username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Masukkan Password (Alfanumerik a-z A-Z 0-9)"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion_1",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                                Profile\n                                                                "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileAll),
      expression: "profileAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "profile",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.profileAll) ? _vm._i(_vm.profileAll, "1") > -1 : (_vm.profileAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profileAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.profileAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.profileAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.profileAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "profile"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne_1",
      "role": "tabpanel",
      "aria-labelledby": "headingOne_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.visi_misi),
      expression: "akses.profile.visi_misi"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "visi_misi",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.visi_misi) ? _vm._i(_vm.akses.profile.visi_misi, "1") > -1 : (_vm.akses.profile.visi_misi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.visi_misi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.visi_misi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.visi_misi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "visi_misi", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visi_misi"
    }
  }, [_vm._v("Visi Misi")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.sejarah_pendirian),
      expression: "akses.profile.sejarah_pendirian"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "sejarah_pendirian",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.sejarah_pendirian) ? _vm._i(_vm.akses.profile.sejarah_pendirian, "1") > -1 : (_vm.akses.profile.sejarah_pendirian)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.sejarah_pendirian,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.sejarah_pendirian = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.sejarah_pendirian = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "sejarah_pendirian", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sejarah_pendirian"
    }
  }, [_vm._v("Sejarah Pendirian")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.pendiri),
      expression: "akses.profile.pendiri"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "pendiri",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.pendiri) ? _vm._i(_vm.akses.profile.pendiri, "1") > -1 : (_vm.akses.profile.pendiri)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.pendiri,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.pendiri = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.pendiri = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "pendiri", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pendiri"
    }
  }, [_vm._v("Pendiri")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.dewan_pengawas),
      expression: "akses.profile.dewan_pengawas"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "dewan_pengawas",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.dewan_pengawas) ? _vm._i(_vm.akses.profile.dewan_pengawas, "1") > -1 : (_vm.akses.profile.dewan_pengawas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.dewan_pengawas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.dewan_pengawas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.dewan_pengawas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "dewan_pengawas", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dewan_pengawas"
    }
  }, [_vm._v("Dewan Pengawas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.pengurus),
      expression: "akses.profile.pengurus"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "pengurus",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.pengurus) ? _vm._i(_vm.akses.profile.pengurus, "1") > -1 : (_vm.akses.profile.pengurus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.pengurus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.pengurus = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.pengurus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "pengurus", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pengurus"
    }
  }, [_vm._v("Pengurus")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.struktur_organisasi),
      expression: "akses.profile.struktur_organisasi"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "struktur_organisasi",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.struktur_organisasi) ? _vm._i(_vm.akses.profile.struktur_organisasi, "1") > -1 : (_vm.akses.profile.struktur_organisasi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.struktur_organisasi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.struktur_organisasi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.struktur_organisasi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "struktur_organisasi", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "struktur_organisasi"
    }
  }, [_vm._v("Struktur Organisasi")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.profile.budaya_kerja),
      expression: "akses.profile.budaya_kerja"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "budaya_kerja",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.profile.budaya_kerja) ? _vm._i(_vm.akses.profile.budaya_kerja, "1") > -1 : (_vm.akses.profile.budaya_kerja)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.profile.budaya_kerja,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.profile.budaya_kerja = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.profile.budaya_kerja = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.profile, "budaya_kerja", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "budaya_kerja"
    }
  }, [_vm._v("Budaya Kerja")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingOne_1"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "data-toggle": "collapse"
    }
  }, [_vm._v("\n                                                                Layanan\n                                                                "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layananAll),
      expression: "layananAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "layanan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.layananAll) ? _vm._i(_vm.layananAll, "1") > -1 : (_vm.layananAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layananAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layananAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layananAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layananAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "layanan"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.cetak_mp),
      expression: "akses.layanan.cetak_mp"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "cetak-mp",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.cetak_mp) ? _vm._i(_vm.akses.layanan.cetak_mp, "1") > -1 : (_vm.akses.layanan.cetak_mp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.cetak_mp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.cetak_mp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.cetak_mp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "cetak_mp", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cetak-mp"
    }
  }, [_vm._v("Cetak StrukMP/Pph21")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.cetak_up),
      expression: "akses.layanan.cetak_up"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "cetak-up",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.cetak_up) ? _vm._i(_vm.akses.layanan.cetak_up, "1") > -1 : (_vm.akses.layanan.cetak_up)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.cetak_up,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.cetak_up = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.cetak_up = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "cetak_up", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cetak-up"
    }
  }, [_vm._v("Cetak Struk Uang Pembinaan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.cetak_rapel),
      expression: "akses.layanan.cetak_rapel"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "cetak-rapel",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.cetak_rapel) ? _vm._i(_vm.akses.layanan.cetak_rapel, "1") > -1 : (_vm.akses.layanan.cetak_rapel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.cetak_rapel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.cetak_rapel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.cetak_rapel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "cetak_rapel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cetak-rapel"
    }
  }, [_vm._v("Cetak Struk Rapel Kenaikan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.cetak_spt),
      expression: "akses.layanan.cetak_spt"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "cetak-spt",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.cetak_spt) ? _vm._i(_vm.akses.layanan.cetak_spt, "1") > -1 : (_vm.akses.layanan.cetak_spt)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.cetak_spt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.cetak_spt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.cetak_spt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "cetak_spt", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cetak-spt"
    }
  }, [_vm._v("Cetak SPT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.atur_ip),
      expression: "akses.layanan.atur_ip"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "identitas-pemotong",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.atur_ip) ? _vm._i(_vm.akses.layanan.atur_ip, "1") > -1 : (_vm.akses.layanan.atur_ip)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.atur_ip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.atur_ip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.atur_ip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "atur_ip", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "identitas-pemotong"
    }
  }, [_vm._v("Atur Identitas Pemotong")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.survey),
      expression: "akses.layanan.survey"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "survey",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.survey) ? _vm._i(_vm.akses.layanan.survey, "1") > -1 : (_vm.akses.layanan.survey)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.survey,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.survey = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.survey = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "survey", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "survey"
    }
  }, [_vm._v("Survey Pelayanan Pensiun")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.hasil_survey),
      expression: "akses.layanan.hasil_survey"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "hasil-survey",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.hasil_survey) ? _vm._i(_vm.akses.layanan.hasil_survey, "1") > -1 : (_vm.akses.layanan.hasil_survey)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.hasil_survey,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.hasil_survey = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.hasil_survey = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "hasil_survey", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hasil-survey"
    }
  }, [_vm._v("Hasil Survey Pelayanan Pensiun")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.data_kelengkapan),
      expression: "akses.layanan.data_kelengkapan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "data-kelengkapan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.data_kelengkapan) ? _vm._i(_vm.akses.layanan.data_kelengkapan, "1") > -1 : (_vm.akses.layanan.data_kelengkapan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.data_kelengkapan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.data_kelengkapan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.data_kelengkapan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "data_kelengkapan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "data-kelengkapan"
    }
  }, [_vm._v("Data Kelengkapan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.pengaduan),
      expression: "akses.layanan.pengaduan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "data-kelengkapan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.pengaduan) ? _vm._i(_vm.akses.layanan.pengaduan, "1") > -1 : (_vm.akses.layanan.pengaduan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.pengaduan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.pengaduan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.pengaduan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "pengaduan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "data-kelengkapan"
    }
  }, [_vm._v("Pengaduan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.layanan.kritik),
      expression: "akses.layanan.kritik"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "data-kelengkapan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.layanan.kritik) ? _vm._i(_vm.akses.layanan.kritik, "1") > -1 : (_vm.akses.layanan.kritik)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.layanan.kritik,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.layanan.kritik = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.layanan.kritik = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.layanan, "kritik", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "data-kelengkapan"
    }
  }, [_vm._v("Kritik")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                                Informasi\n                                                                "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informasiAll),
      expression: "informasiAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "informasi",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.informasiAll) ? _vm._i(_vm.informasiAll, "1") > -1 : (_vm.informasiAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.informasiAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.informasiAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.informasiAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.informasiAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "informasi"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.informasi.kegiatan),
      expression: "akses.informasi.kegiatan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "kegiatan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.informasi.kegiatan) ? _vm._i(_vm.akses.informasi.kegiatan, "1") > -1 : (_vm.akses.informasi.kegiatan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.informasi.kegiatan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.informasi.kegiatan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.informasi.kegiatan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.informasi, "kegiatan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kegiatan"
    }
  }, [_vm._v("Kegiatan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.informasi.artikel),
      expression: "akses.informasi.artikel"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "Artikel",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.informasi.artikel) ? _vm._i(_vm.akses.informasi.artikel, "1") > -1 : (_vm.akses.informasi.artikel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.informasi.artikel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.informasi.artikel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.informasi.artikel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.informasi, "artikel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Artikel"
    }
  }, [_vm._v("Artikel")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.informasi.perkembangan),
      expression: "akses.informasi.perkembangan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "perkembangan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.informasi.perkembangan) ? _vm._i(_vm.akses.informasi.perkembangan, "1") > -1 : (_vm.akses.informasi.perkembangan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.informasi.perkembangan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.informasi.perkembangan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.informasi.perkembangan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.informasi, "perkembangan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "perkembangan"
    }
  }, [_vm._v("Perkembangan Investasi Semesteran")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.informasi.tahunan),
      expression: "akses.informasi.tahunan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "tahunan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.informasi.tahunan) ? _vm._i(_vm.akses.informasi.tahunan, "1") > -1 : (_vm.akses.informasi.tahunan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.informasi.tahunan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.informasi.tahunan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.informasi.tahunan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.informasi, "tahunan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tahunan"
    }
  }, [_vm._v("Laporan Keuangan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.informasi.lowongan),
      expression: "akses.informasi.lowongan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "lowongan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.informasi.lowongan) ? _vm._i(_vm.akses.informasi.lowongan, "1") > -1 : (_vm.akses.informasi.lowongan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.informasi.lowongan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.informasi.lowongan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.informasi.lowongan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.informasi, "lowongan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lowongan"
    }
  }, [_vm._v("Lowongan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.informasi.galeri),
      expression: "akses.informasi.galeri"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "galeri",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.informasi.galeri) ? _vm._i(_vm.akses.informasi.galeri, "1") > -1 : (_vm.akses.informasi.galeri)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.informasi.galeri,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.informasi.galeri = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.informasi.galeri = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.informasi, "galeri", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "galeri"
    }
  }, [_vm._v("Galeri")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                                Unduh\n                                                                "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unduhAll),
      expression: "unduhAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "unduh",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.unduhAll) ? _vm._i(_vm.unduhAll, "1") > -1 : (_vm.unduhAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.unduhAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.unduhAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.unduhAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.unduhAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "unduh"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.pdp),
      expression: "akses.unduh.pdp"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "pdp",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.pdp) ? _vm._i(_vm.akses.unduh.pdp, "1") > -1 : (_vm.akses.unduh.pdp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.pdp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.pdp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.pdp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "pdp", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pdp"
    }
  }, [_vm._v("PDP")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.arahan),
      expression: "akses.unduh.arahan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "arahan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.arahan) ? _vm._i(_vm.akses.unduh.arahan, "1") > -1 : (_vm.akses.unduh.arahan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.arahan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.arahan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.arahan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "arahan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "arahan"
    }
  }, [_vm._v("Arahan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.regulasi),
      expression: "akses.unduh.regulasi"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "regulasi",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.regulasi) ? _vm._i(_vm.akses.unduh.regulasi, "1") > -1 : (_vm.akses.unduh.regulasi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.regulasi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.regulasi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.regulasi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "regulasi", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "regulasi"
    }
  }, [_vm._v("Regulasi Dana Pensiun")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.majalah),
      expression: "akses.unduh.majalah"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "majalah",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.majalah) ? _vm._i(_vm.akses.unduh.majalah, "1") > -1 : (_vm.akses.unduh.majalah)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.majalah,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.majalah = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.majalah = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "majalah", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "majalah"
    }
  }, [_vm._v("Majalah DAPENBI")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.materikomunikasi),
      expression: "akses.unduh.materikomunikasi"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "materikomunikasi",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.materikomunikasi) ? _vm._i(_vm.akses.unduh.materikomunikasi, "1") > -1 : (_vm.akses.unduh.materikomunikasi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.materikomunikasi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.materikomunikasi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.materikomunikasi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "materikomunikasi", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "materikomunikasi"
    }
  }, [_vm._v("Materi Komunikasi")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.laporan),
      expression: "akses.unduh.laporan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "laporan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.laporan) ? _vm._i(_vm.akses.unduh.laporan, "1") > -1 : (_vm.akses.unduh.laporan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.laporan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.laporan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.laporan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "laporan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "laporan"
    }
  }, [_vm._v("Laporan")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.unduh.formulir),
      expression: "akses.unduh.formulir"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "formulir",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.unduh.formulir) ? _vm._i(_vm.akses.unduh.formulir, "1") > -1 : (_vm.akses.unduh.formulir)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.unduh.formulir,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.unduh.formulir = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.unduh.formulir = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses.unduh, "formulir", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "formulir"
    }
  }, [_vm._v("Formulir")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Master Narasumber\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.masterNarasumber),
      expression: "akses.masterNarasumber"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "masterNarasumber",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.masterNarasumber) ? _vm._i(_vm.akses.masterNarasumber, "1") > -1 : (_vm.akses.masterNarasumber)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.masterNarasumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.masterNarasumber = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.masterNarasumber = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "masterNarasumber", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "masterNarasumber"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        User Level\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.userLevel),
      expression: "akses.userLevel"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "userLevel",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.userLevel) ? _vm._i(_vm.akses.userLevel, "1") > -1 : (_vm.akses.userLevel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.userLevel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.userLevel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.userLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "userLevel", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "userLevel"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Data Anggota\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.anggota),
      expression: "akses.anggota"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "anggota",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.anggota) ? _vm._i(_vm.akses.anggota, "1") > -1 : (_vm.akses.anggota)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.anggota,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.anggota = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.anggota = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "anggota", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "anggota"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Log\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.log),
      expression: "akses.log"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "log",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.log) ? _vm._i(_vm.akses.log, "1") > -1 : (_vm.akses.log)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.log,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.log = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.log = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "log", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "log"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        FAQ\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.faq),
      expression: "akses.faq"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "faq",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.faq) ? _vm._i(_vm.akses.faq, "1") > -1 : (_vm.akses.faq)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.faq,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.faq = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.faq = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "faq", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "faq"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Syarat Kepesertaan\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.syarat),
      expression: "akses.syarat"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "syarat",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.syarat) ? _vm._i(_vm.akses.syarat, "1") > -1 : (_vm.akses.syarat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.syarat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.syarat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.syarat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "syarat", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "syarat"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Cara Mendaftar\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.cara),
      expression: "akses.cara"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "cara",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.cara) ? _vm._i(_vm.akses.cara, "1") > -1 : (_vm.akses.cara)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.cara,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.cara = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.cara = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "cara", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cara"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Slider\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.slider),
      expression: "akses.slider"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "slider",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.slider) ? _vm._i(_vm.akses.slider, "1") > -1 : (_vm.akses.slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.slider = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.slider = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "slider", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "slider"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Kirim Notifikasi\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.kirimNotifikasi),
      expression: "akses.kirimNotifikasi"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "kirimNotifikasi",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.kirimNotifikasi) ? _vm._i(_vm.akses.kirimNotifikasi, "1") > -1 : (_vm.akses.kirimNotifikasi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.kirimNotifikasi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.kirimNotifikasi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.kirimNotifikasi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "kirimNotifikasi", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kirimNotifikasi"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Headline\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.headline),
      expression: "akses.headline"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "headline",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.headline) ? _vm._i(_vm.akses.headline, "1") > -1 : (_vm.akses.headline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.headline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.headline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.headline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "headline", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "headline"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        WhistleBlower\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.whistleBlower),
      expression: "akses.whistleBlower"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "whistleBlower",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.whistleBlower) ? _vm._i(_vm.akses.whistleBlower, "1") > -1 : (_vm.akses.whistleBlower)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.whistleBlower,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.whistleBlower = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.whistleBlower = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "whistleBlower", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "whistleBlower"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Anak Perusahaan\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.anakPerusahaan),
      expression: "akses.anakPerusahaan"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "anakPerusahaan",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.anakPerusahaan) ? _vm._i(_vm.akses.anakPerusahaan, "1") > -1 : (_vm.akses.anakPerusahaan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.anakPerusahaan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.anakPerusahaan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.anakPerusahaan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "anakPerusahaan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "anakPerusahaan"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Pengumuman\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.Pengumuman),
      expression: "akses.Pengumuman"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "Pengumuman",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.Pengumuman) ? _vm._i(_vm.akses.Pengumuman, "1") > -1 : (_vm.akses.Pengumuman)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.Pengumuman,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.Pengumuman = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.Pengumuman = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "Pengumuman", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Pengumuman"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Kalender\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.Kalender),
      expression: "akses.Kalender"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "Kalender",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.Kalender) ? _vm._i(_vm.akses.Kalender, "1") > -1 : (_vm.akses.Kalender)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.Kalender,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.Kalender = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.Kalender = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "Kalender", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Kalender"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Hak dan Kewajiabn Peserta\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.Hak_dan_Kewajiban_Peserta),
      expression: "akses.Hak_dan_Kewajiban_Peserta"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "hakDanKewajibanPeserta"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.Hak_dan_Kewajiban_Peserta) ? _vm._i(_vm.akses.Hak_dan_Kewajiban_Peserta, null) > -1 : (_vm.akses.Hak_dan_Kewajiban_Peserta)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.Hak_dan_Kewajiban_Peserta,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.Hak_dan_Kewajiban_Peserta = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.Hak_dan_Kewajiban_Peserta = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "Hak_dan_Kewajiban_Peserta", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hakDanKewajibanPeserta"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Hak_dan_Kewajiban_Peserta"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Banner\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.Banner),
      expression: "akses.Banner"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "Banner",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.Banner) ? _vm._i(_vm.akses.Banner, "1") > -1 : (_vm.akses.Banner)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.Banner,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.Banner = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.Banner = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "Banner", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Banner"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("\n                                                        Hubungi Kami\n                                                        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.akses.hubungiKami),
      expression: "akses.hubungiKami"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "hubungiKami",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.akses.hubungiKami) ? _vm._i(_vm.akses.hubungiKami, "1") > -1 : (_vm.akses.hubungiKami)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.akses.hubungiKami,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.akses.hubungiKami = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.akses.hubungiKami = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.akses, "hubungiKami", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hubungiKami"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [(_vm.id_user != null) ? _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-warning waves-effect waves-button",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": _vm.update
    }
  }, [(!_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" Edit")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading")])]) : _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-primary waves-effect waves-button",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [(!_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" Simpan")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Batal")])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v("User Level")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("\n                            Tambah User Level\n                        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "id_narasumber"
    }
  }, [_vm._v("Narasumber")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "namaLengkap"
    }
  }, [_vm._v("Nama Lengkap")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Akses Menu")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af71b88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Admin/FormAdmin.vue
// module id = wj5t
// module chunks = 1